
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","viewBox":"0 0 34 34","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17 .2C7.7.2.2 7.7.2 17S7.7 33.8 17 33.8 33.8 26.3 33.8 17 26.3.2 17 .2zm0 31.6C8.8 31.8 2.2 25.2 2.2 17c0-1.5.2-3 .6-4.3 5.3-.6 9.7-4.3 11.1-9.3 1.6 5.9 7 10.3 13.4 10.3 1.4 0 2.7-.2 3.9-.6.3 1.2.5 2.5.5 3.9.1 8.2-6.5 14.8-14.7 14.8z"}}),_c('path',{attrs:{"d":"M11.9 19.7a1.8 1.8 0 100-3.6 1.8 1.8 0 000 3.6zm10 0a1.8 1.8 0 100-3.6 1.8 1.8 0 000 3.6zM21.9 22.4c0 2.9-2.3 5.2-5.2 5.2-2.9 0-5.2-2.3-5.2-5.2h10.4z"}})])
          )
        }
      }
    